import { MenuItemIcon } from '@/components/MenuItem/MenuItemIcon';
import BringForward from '@/images/position/Forward.svg';
import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import { bringElementsForward } from '../../../../actions/arrange/BringForward';
interface Props {
    disabled: boolean;
}

export const BringForwardMenuItem = ({ disabled }: Props) => {
    const { store } = useAdvancedEditorContext();
    const selectedElements = store.selectedElements;

    const handleClick = () => {
        bringElementsForward(store, selectedElements);
    };

    return <MenuItemIcon disabled={disabled} onClick={handleClick} src={BringForward} text="Bring forward" />;
};
